/** angular */
import { NgModule } from '@angular/core';
/** end angular */

/** pipes */
import { BydGetBlobUrlPipe } from './byd-get-blob-url.pipe';
/** end pipes */

const pipes = [BydGetBlobUrlPipe];

@NgModule({
  declarations: [pipes],
  exports: [pipes],
  providers: [pipes],
})
export class BydGetBlobUrlModule {}
